import { startTransition, useCallback, useRef, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { ShowMessageDialog } from "../utils/dialogUtlities";
import DefaultButton from "./DefaultButton";
import { PasswordResetCtrl } from "./PasswordReset";
import ReactForm from "./ReactForm";
import PropTypes from 'prop-types';
import { fetch } from "../utils/fetch";
import { useNavigate } from "../hooks/navigateHook";

const ResetPassword = ({ username, resetToken }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [value, setValue] = useState({});
    const [submitted, setSubmitted] = useState(false);
    const [success, setSuccess] = useState();
    const formRef = useRef();

    const doChange = useCallback(async () => {
        if (formRef.current?.checkValidity()) {
            setSubmitted(true);
            try {
                const response = await fetch('/api/v1/resetPassword', {
                    method: 'POST',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ username, resetToken, password: value.password })
                });
                if (response.ok) {
                    setSuccess(true);
                }
            } catch {
                setSuccess(false);
            } finally {
                setSubmitted(false);
                setValue({});
            }
        }
    }, [value, username, resetToken]);

    const redirect = useCallback(() => {
        startTransition(() => {
            navigate('/')
        })
    }, [navigate]);

    return <div style={{ marginLeft: 'auto', marginRight: 'auto', maxWidth: '500px', color: 'white' }}>
        <ShowMessageDialog showModal={success === true} message={t('resetPasswordSuccess')} onClose={redirect}></ShowMessageDialog>
        { success === undefined && <ReactForm ref={formRef}>
            <Row>
                <Col>{t('resetPasswordInstruction')}</Col>
            </Row>
            <Row>
                <Col>
                    <PasswordResetCtrl value={value} requireCurrent={false} onChange={delta => setValue(value => ({ ...value, ...delta }))}></PasswordResetCtrl>
                </Col>
            </Row>
            <Row>
                <Col className="px-1 py-2">
                    <DefaultButton className="w-100" kind="submit" processing={submitted} onClick={doChange}></DefaultButton>
                </Col>
            </Row>
        </ReactForm> }
        { success === false && <p>{t('resetPasswordFailure')}</p> }
    </div>
}

ResetPassword.propTypes = {
    /**
     * Username whose password we are resetting
     */
    username: PropTypes.string,
    /**
     * Reset token used to validate the reset request
     */
    resetToken: PropTypes.string
}

export default ResetPassword;